// extracted by mini-css-extract-plugin
module.exports = {"list":"utilities-layout_list__1VbIK"};